var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { getColor } from '../helpers/ColorHelpers';
import { belowBreakpointOrEqual, belowBreakpoint, aboveBreakpointOrEqual, aboveBreakpoint, appendPx } from '../theme/DefaultTheme';
import LottieIcon from './LottieIcon';
import { getAnimation } from '../theme/Animations';
import { styled, ImgThemeConsumer } from '../theme/ThemeHelpers';
export function getAlertInputProp(props, value) {
    var v;
    var kind = props.kind;
    if (kind) {
        v = props.theme.alerts.kinds[kind][value];
    }
    return v ? v : "";
}
var AlertContainerTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    color:", ";\n    font-weight: 900;\n    font-size: ", ";\n    left: ", ";\n    bottom: ", ";\n"], ["\n    position: absolute;\n    color:",
    ";\n    font-weight: 900;\n    font-size: ", ";\n    left: ", ";\n    bottom: ", ";\n"])), function (props) {
    return props.kind === "error" ? getColor(props, props.theme.colors.alertInfoErrorTitle) :
        props.kind === "warning" ? getColor(props, props.theme.colors.alertInfoWarningTitle) :
            props.kind === "success" ? getColor(props, props.theme.colors.alertInfoSuccessTitle) :
                getColor(props, props.theme.colors.alertInfoInformationTitle);
}, function (props) { return props.mobile ? "3em" : props.tablet ? "4em" : props.desktop ? "7em" : "7em"; }, function (props) { return appendPx(props.mobile ? -5 : props.tablet ? -7 : props.desktop ? -10 : -10); }, function (props) { return appendPx(props.mobile ? 105 : props.tablet ? 105 : props.tablet ? 115 : 115); });
var LottieContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position:absolute;\n    bottom: ", ";\n    right: ", ";\n    width: ", ";\n    height: ", ";\n"], ["\n    position:absolute;\n    bottom: ", ";\n    right: ", ";\n    width: ", ";\n    height: ", ";\n"])), function (props) { return appendPx(props.mobile ? 70 : props.tablet ? 60 : props.desktop ? 40 : 40); }, function (props) { return appendPx(props.mobile ? -40 : props.tablet ? -40 : props.desktop ? -80 : -80); }, function (props) { return appendPx(props.mobile ? 120 : props.tablet ? 150 : props.desktop ? 240 : 240); }, function (props) { return appendPx(props.mobile ? 120 : props.tablet ? 150 : props.desktop ? 240 : 240); });
var AlertContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 100px;\n    overflow-y: hidden;\n    width: 100%;\n    position: relative;\n    left:0;\n    padding:10px;\n    background:", ";\n    z-index: 40;\n    font-size:0.8rem;\n"], ["\n    height: 100px;\n    overflow-y: hidden;\n    width: 100%;\n    position: relative;\n    left:0;\n    padding:10px;\n    background:", ";\n    z-index: 40;\n    font-size:0.8rem;\n"])), function (props) { return getColor(props, getAlertInputProp(props, "color")); });
var AlertContainerContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    width: 100%;\n    left:0;\n    bottom: 0px;\n    animation: ", " ", "s;\n    transform: scale(", ");\n    pointer-events: all;\n"], ["\n    position: absolute;\n    width: 100%;\n    left:0;\n    bottom: 0px;\n    animation: ", " ", "s;\n    transform: scale(", ");\n    pointer-events: all;\n"])), function (props) { return !props.initial && getAnimation(props.theme.alerts[props.active ? "start" : "end"]); }, function (props) { return props.theme.alerts.animationDuration; }, function (props) { return props.active ? 1 : 0; });
var SimulatedParent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: fixed;\n    top: ", "px;\n    left: ", "px;\n    width: ", "px;\n    height: ", "px;\n    pointer-events: none;\n    overflow:hidden;\n"], ["\n    position: fixed;\n    top: ", "px;\n    left: ", "px;\n    width: ", "px;\n    height: ", "px;\n    pointer-events: none;\n    overflow:hidden;\n"])), function (props) { return props.rect.top; }, function (props) { return props.rect.left; }, function (props) { return props.rect.width; }, function (props) { return props.rect.height; });
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert(props) {
        var _this = _super.call(this, props) || this;
        _this.mounted = false;
        _this.state = {
            initial: true,
            active: false,
        };
        return _this;
    }
    Alert.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        this.mounted = true;
        var active = this.props.active;
        if (prevState.active !== active) {
            var call = function () {
                if (_this.mounted)
                    _this.setState({ active: active ? active : false, initial: false });
            };
            if (!active)
                setTimeout(call, 1000);
            else
                call();
        }
    };
    Alert.prototype.componentWillUnmount = function () {
        this.mounted = false;
    };
    Alert.prototype.render = function () {
        var _this = this;
        var _a = this.props, parent = _a.parent, kind = _a.kind, timeout = _a.timeout;
        var active = this.state.active;
        if (timeout) {
            var close_1 = function () { return _this.setState({ active: false }); };
            setTimeout(close_1, timeout);
        }
        if (parent && active) {
            var cr_1 = parent.getBoundingClientRect();
            return (React.createElement(ImgThemeConsumer, null, function (theme) {
                var mobile = belowBreakpoint({ theme: theme }, "tablet");
                var tablet = aboveBreakpointOrEqual({ theme: theme }, "tablet") && belowBreakpointOrEqual({ theme: theme }, "desktop");
                var desktop = aboveBreakpoint({ theme: theme }, "desktop");
                return (React.createElement(SimulatedParent, { rect: cr_1 },
                    React.createElement(AlertContainerContainer, __assign({}, _this.state, _this.props),
                        React.createElement(AlertContainerTitle, __assign({}, _this.props, _this.state, { kind: kind, mobile: mobile, tablet: tablet, desktop: desktop }), kind),
                        React.createElement(LottieContainer, __assign({}, _this.props, _this.state, { kind: kind, mobile: mobile, tablet: tablet, desktop: desktop }),
                            React.createElement(LottieIcon, { url: "./images/lottiIcons/i" + kind + ".json", autoplay: true })),
                        React.createElement(AlertContainer, __assign({}, _this.state, _this.props)))));
            }));
        }
        else
            return null;
    };
    return Alert;
}(React.PureComponent));
export default Alert;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Alert.js.map